<body id="style-2">
  <div class="header">
    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-lg-4">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(nov-13)/images/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="social_box">
            <a href="http://onpassive.com/blog" target="_blank" rel="noopener">
              <i class="fa fa-rss icon" aria-hidden="true"></i
            ></a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
            >
              <i class="fa fa-facebook icon" aria-hidden="true"></i
            ></a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              ><i class="fa fa-twitter icon" aria-hidden="true"></i
            ></a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              ><i class="fa fa-linkedin icon" aria-hidden="true"></i
            ></a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              ><i class="fa fa-youtube icon" aria-hidden="true"></i
            ></a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              ><i class="fa fa-instagram icon" aria-hidden="true"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="mid_box">
      <div class="row">
        <div class="col-lg-4 right mob">
          <div class="first_box">
            <h1>Digital</h1>
            <h4>marketing</h4>
            <p>
              A world-class digital marketing platform built just for you.
              Launch your Internet marketing business to a whole new level with
              the right tools.
            </p>
            <div class="left_image">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(nov-13)/images/left_image.jpg"
                alt="image"
              />
            </div>

            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="btn11"
            >
              <span>BECOME A FOUNDER NOW</span>
              <div class="transition"></div>
            </a>
          </div>
        </div>
        <div class="col-lg-4 right mob_top">
          <div class="sec_box">
            <div class="flye_box">
              <div class="round_image">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(nov-13)/images/round_image.png"
                  alt="image"
                />
                <div class="air_image">
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(nov-13)/images/plane.png"
                    alt="image"
                  />
                </div>
              </div>
              <div class="cloud">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(nov-13)/images/cloud_image.png"
                  alt="image"
                />
              </div>
            </div>
            <div class="launching_box">
              <h1>LAUNCHING S<span>OO</span>N!</h1>
              <p>
                It is not about where you are going, it is about how you are
                going and the path you are taking to reach your goals.
                <span>ONPASSIVE</span>, a profound digital marketing platform is
                equipped with automated tools to revolutionise the marketing
                world.
              </p>
              <p>
                Use the right <span>solutions</span> for the perfect launch of
                your business. Get in touch with us for a life changing
                opportunity.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="third_box">
            <h1>NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS</h1>
            <p>
              With automated marketing solutions, you need not worry about doing
              things manually. Get traffic to your sites automatically, perform
              multifunctional campaigns across various channels at a time and
              more internet marketing solutions tailored just for you.
            </p>
            <div class="video_box acc_panel anim_in">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="footer">
        <p>&copy; 2022 ONPASSIVE - All Rights Reserved</p>
      </div>
    </div>
  </div>
</body>
